import { Component } from '@angular/core';

@Component({
    selector: 'app-upcoming-training',
    templateUrl: './upcoming-training.component.html',
    styleUrl: './upcoming-training.component.scss',
  host: {
    class: 'row flex-grow-1'
  },
    standalone: false
})
export class UpcomingTrainingComponent {

}
